import { render, staticRenderFns } from "./wallet-box2.vue?vue&type=template&id=ae0ecf48&scoped=true&"
import script from "./wallet-box2.vue?vue&type=script&lang=js&"
export * from "./wallet-box2.vue?vue&type=script&lang=js&"
import style0 from "./wallet-box2.vue?vue&type=style&index=0&id=ae0ecf48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0ecf48",
  null
  
)

export default component.exports